import type { ContractData } from './claimIntakeUtils';
import { buildCustomerAddressFromContract } from './buildUnifiedClaimPayload';

/**
 * Field labels match Dynamic form labels (paths). Used in mid-call `form_update`
 * so the voice agent skips asking for values already filled from contract lookup.
 */
export function buildVoiceFormUpdateFieldsFromContract(
  contract: ContractData
): Record<string, string> {
  const name = [contract.customer?.firstName, contract.customer?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  const addr = buildCustomerAddressFromContract(contract);
  const vin = contract.vehicle?.vin?.trim() ?? '';
  const policyId = contract.contractNumber?.trim() ?? '';
  const fields: Record<string, string> = {};

  const put = (label: string, value: string) => {
    const v = value.trim();
    if (v) fields[label] = v;
  };

  put('policies.policy_id', policyId);
  put('product.product_id', vin);
  put('customer.name', name);
  put('customer.phone_no', contract.customer?.phone ?? '');
  put('customer.address.address1', addr.address1);
  put('customer.address.address2', addr.address2);
  put('customer.address.city', addr.city);
  put('customer.address.state', addr.state);
  put('customer.address.postal_code', addr.postal_code);
  put('customer.address.country_code', addr.country_code);

  return fields;
}
